import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=f6a3ff56&scoped=true"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"
import style0 from "./Multiple.vue?vue&type=style&index=0&id=f6a3ff56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_65179a06be82c71d607b9dd0dd22b0bf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a3ff56",
  null
  
)

export default component.exports